import { render, staticRenderFns } from "./evaluatingQuestionCreate.vue?vue&type=template&id=1aa7c128&scoped=true&"
import script from "./evaluatingQuestionCreate.vue?vue&type=script&lang=ts&"
export * from "./evaluatingQuestionCreate.vue?vue&type=script&lang=ts&"
import style0 from "./evaluatingQuestionCreate.vue?vue&type=style&index=0&id=1aa7c128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7c128",
  null
  
)

export default component.exports